import { handleMessages } from 'poly-eshop4/eshop/ui/js/util';
import { filterEventHandler } from 'poly-eshop4/eshop/ui/js/itemlist';

$(document).on('submit', '[data-rackjobber-vmi-update-form]', function(event) {
  event.preventDefault();

  const $form = $(this);
  const method = $form.attr('data-rackjobber-vmi-update-form');
  const $reveal = $form.closest('[data-reveal]');
  $reveal.addClass('loading');
  $.ajax({
    url: $form.attr('action'),
    method: 'POST',
    data: $form.serialize(),
  }).then(handleMessages).then((data) => {
    if (data.num_pos !== undefined) {
      if (!data.num_pos) {
        $('[data-rj-cart-badge]').addClass('hide').text('');
      } else {
        $('[data-rj-cart-badge]').removeClass('hide').text(data.num_pos);
      }
    }
    if (method === 'add') {
      if (data.num_pos === undefined) {
        const promise = filterEventHandler.bind($('#itemlist'))();
        if (promise) {
          return promise.then(() => {
            setTimeout(() => $form.closest('[data-reveal]').foundation('close').remove(), 500);
          });
        }
      } else {
        $reveal.removeClass('loading');
        if (data.status) {
          $reveal.addClass('loaded');
          setTimeout(() => {
            $reveal.removeClass('loading').removeClass('loaded').foundation('close');
            $form[0].reset();
          }, 500);
        } else {
          $form[0].reset();
          $reveal.removeClass('loading').removeClass('loaded').foundation('close');
        }
      }
    } else {
      $reveal.removeClass('loading').addClass('loaded');
      document.location.reload();
    }
    return Promise.resolve();
  }).catch(() => {
    $reveal.removeClass('loading');
  });
});

$(document).on('scan', '[data-rj-items-search]', function(event, scanner, result) {
  $('[data-scanner-wrapper]').addClass('hide');
  scanner.stop();
  scanner.picker.beepSound.play();
  $(this).find('[name=q]').val(result.barcodes[0].data);
  $(this).submit();
});
